import { Component }		from '@angular/core'
import { DomSanitizer }	from '@angular/platform-browser'
import { StateService }	from '../../'

@Component({
  selector:			'app-iab',
  styleUrls:		['./iab.component.scss'],
  templateUrl:	'./iab.component.html'
})
export class IABComponent {
  currentUrl				= this.sanitizer.bypassSecurityTrustResourceUrl('about:blank')
  currentUrlString	= ''
  navigator: any = window.navigator;

	constructor(public sanitizer: DomSanitizer, public stateService: StateService) {
		stateService.iab.subscribe(data => { this.gotState(data) })
	}

	closeClick() {
		this.stateService.state = 'map';
	}

	gotState(state: any) {
		if (typeof state.url === 'string') {
			if (state.url.length > 0 && state.url !== this.currentUrlString) {
				this.currentUrlString	= state.url
				this.currentUrl				= this.sanitizer.bypassSecurityTrustResourceUrl('about:blank')
				
				setTimeout((t, url) => {
					t.currentUrl = t.sanitizer.bypassSecurityTrustResourceUrl(url)
				}, 50, this, state.url)
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/iab/iab.component.ts